// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ICalendarDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-icalendarcontainer" */ "./ICalendarDialogContainer")).then((bundle)=>{
        return {
            default: bundle.ICalendarDialogContainer
        };
    });
export const LazyICalendarDialogContainer = /*#__PURE__*/ lazy(ICalendarDialogContainerLazyLoader);
